export enum NumberGroupGranularityType {
  Exact = 'exact',
  Bin1 = 'bin1',
  Bin10 = 'bin10',
  Bin100 = 'bin100',
  Bin1000 = 'bin1000',
  Custom = 'custom',
}
